import React from 'react';
import NavigationBar from './NavigationBar';

export const PageLayout = ({ children }) => {
    return (
        <>
            <NavigationBar />
            <br />
            {children}
        </>
    );
};
